import { Hint } from '@/Ship/Components/Hint'
import { formTemplateWithBlocks } from '@/Ship/Templates/Form/formTemplateWithBlocks'

/**
 * Підказка про код і системні записи — у формі статусів і причин програшу,
 * над полем «Код» (`SPEC-007` §12, `settings.lists.code`).
 *
 * Компонент один на дев'ять довідників — інакше вартовий унікальності `id`
 * підказок бачив би дев'ять однакових.
 */
export const DictionaryCodeHint = () => (
    <Hint id="settings.lists.code">
        Код — латиниця в нижньому регістрі, цифри, «-» і «_». Системний запис не видаляється, і його код не
        змінюється: на них спирається логіка.
    </Hint>
)

/** Форма довідника статусів чи причин: ядрова форма + підказка над «Кодом». */
export const dictionaryCodeFormTemplate = formTemplateWithBlocks({ code: DictionaryCodeHint })
